const OpenSideMenuIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clipPath="url(#clip0_590_7897)">
          <g filter="url(#filter0_d_590_7897)">
            <path
              d="M16 32C7.17731 32 0 24.8227 0 16C0 7.17731 7.17731 0 16 0C24.8227 0 32 7.17731 32 16C32 24.8227 24.8227 32 16 32ZM20.9427 15.0573L14.276 8.39069C14.016 8.13069 13.6747 8 13.3333 8C12.992 8 12.6506 8.13069 12.3906 8.39069C11.8693 8.912 11.8693 9.75469 12.3906 10.276L18.1147 16L12.3907 21.724C11.8694 22.2453 11.8694 23.088 12.3907 23.6093C12.912 24.1306 13.7547 24.1306 14.276 23.6093L20.9427 16.9426C21.464 16.4213 21.464 15.5787 20.9427 15.0573Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_590_7897"
            x="-4"
            y="-4"
            width="40"
            height="40"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_590_7897"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_590_7897"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_590_7897">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="matrix(1 0 0 -1 0 32)"
            />
          </clipPath>
        </defs>
      </svg>
  );
};
export default OpenSideMenuIcon;
